<template>
 
    <div v-if="hasProjectIdInDefaults" class="col-12 form__control-group field-group">
      <label class="label-spacing">Project</label>
      <UidName :id="props.defaultValues.project_id" :name="props.defaultValues.project_name || ''" prefix="p" />
    </div>
    <div v-else-if="enableProjectSelection" class="col-12 form__control-group field-group">
      <label class="label-spacing"  :for="`select-project-input-${parent}-${schemaField.name}`">
        Project
        <SVGIcon
          v-if="schemaField.description"
          v-tooltip="schemaField.description"
          :width="'20px'"
          :height="'20px'"
          :iconName="'info'"
          class="help-logo"
        />
      </label>
      <select
        :id="`select-project-input-${parent}-${schemaField.name}`"
        :value="selectedProjectId"
        class="select"
        @input="onChangeProject($event.target.value)"
      >
        <option value="" disabled selected>Select Project</option>
        <option
          v-for="(project, i) in projects"
          :key="`dropdown-project-${parent}-${schemaField.name}-${i}-${project.id}`"
          :value="project.id"
        >
          {{ project.name }}
        </option>
      </select>
    </div>

    <div class="col-12 form__control-group field-group">
      <label class="label-spacing"  :for="`select-dataset-input-${parent}-${schemaField.name}`">
       Dataset
        <SVGIcon
          v-if="schemaField.description"
          v-tooltip="schemaField.description"
          :width="'20px'"
          :height="'20px'"
          :iconName="'info'"
          class="help-logo"
        />
      </label>
      <select
        :id="`select-dataset-input-${parent}-${schemaField.name}`"
        :value="internalDatasetId"
        class="select"
        @input="onChangeDataset(parseInt($event.target.value))"
      >
        <option value="" disabled selected>Select Dataset</option>
        <option
          v-for="(dataset, i) in datasets"
          :key="`dropdown-${parent}-${schemaField.name}-${i}-${dataset.name}`"
          :value="dataset.id"
        >
          {{ dataset.name }}
        </option>
      </select>
    </div>

    <div v-if="enableTagsSelection && showNoTagsMessage" class="col-12 form__control-group field-group empty-tags-state">
      <label class="label-spacing">Tag</label>
      <div class="empty-tags-state__row">
        <div class="empty-tags-state__message">No tag is created</div>
        <button type="button" class="button button-sm" @click="openCreateTagDialog">
          Create Dataset Tag
        </button>
      </div>
    </div>

    <div v-else-if="enableTagsSelection" class="col-12 form__control-group field-group">
      <label class="label-spacing" :for="`select-tag-input-${parent}-${schemaField.name}`">
        Tag
        <SVGIcon
          v-if="schemaField.description"
          v-tooltip="'Select a tag version'"
          :width="'20px'"
          :height="'20px'"
          :iconName="'info'"
          class="help-logo"
        />
      </label>
      <select
        :id="`select-tag-input-${parent}-${schemaField.name}`"
        v-model="selectedTag"
        class="select"
      >
        <option value="" disabled selected>Select Tag</option>
        <option
          v-for="(tag, i) in tags"
          :key="`dropdown-tag-${parent}-${schemaField.name}-${i}-${tag.name}`"
          :value="tag.name"
        >
          {{ tag.name }}
        </option>
      </select>
    </div>

    <CreateDatasetTagDialog
      v-if="internalDatasetId"
      v-model:show="showCreateTagDialog"
      :dataset-id="internalDatasetId"
      @created="handleDatasetTagCreated"
    />

    <div v-if="enableAnnotationSetSelection && internalDatasetId" class="col-12 form__control-group field-group">
      <label class="label-spacing" :for="`select-annotation-set-input-${parent}-${schemaField.name}`">
        Annotation Set
        <SVGIcon
          v-if="schemaField.description"
          v-tooltip="'Select an annotation set'"
          :width="'20px'"
          :height="'20px'"
          :iconName="'info'"
          class="help-logo"
        />
      </label>
      <select
        :id="`select-annotation-set-input-${parent}-${schemaField.name}`"
        v-model="selectedAnnotationSet"
        class="select"
      >
        <option value="" disabled selected>Select Annotation Set</option>
        <option
          v-for="(annotationSet, i) in annotationSets"
          :key="`dropdown-annotation-set-${parent}-${schemaField.name}-${i}-${annotationSet.name}`"
          :value="annotationSet.id"
        >
          {{ annotationSet.name }}
        </option>
      </select>
    </div>

    <div v-if="enableGroupSelection && internalDatasetId" class="col-12 form__control-group field-group">
      <label class="label-spacing" :for="`select-train-group-input-${parent}-${schemaField.name}`">
        Train Group
        <SVGIcon
          v-if="schemaField.description"
          v-tooltip="'Select a training group'"
          :width="'20px'"
          :height="'20px'"
          :iconName="'info'"
          class="help-logo"
        />
      </label>
      <select
        :id="`select-train-group-input-${parent}-${schemaField.name}`"
        v-model="selectedTrainGroup"
        class="select"
      >
        <option value="" disabled selected>Select Train Group</option>
        <option
          v-for="(group, i) in groups"
          :key="`dropdown-train-group-${parent}-${schemaField.name}-${i}-${group.name}`"
          :value="group"
        >
          {{ group.name }}
        </option>
      </select>
    </div>

    <div v-if="enableGroupSelection && internalDatasetId" class="col-12 form__control-group field-group">
      <label class="label-spacing" :for="`select-val-group-input-${parent}-${schemaField.name}`">
        Val Group
        <SVGIcon
          v-if="schemaField.description"
          v-tooltip="'Select a validation group'"
          :width="'20px'"
          :height="'20px'"
          :iconName="'info'"
          class="help-logo"
        />
      </label>
      <select
        :id="`select-val-group-input-${parent}-${schemaField.name}`"
        v-model="selectedValGroup"
        class="select"
      >
        <option value="" disabled selected>Select Val Group</option>
        <option
          v-for="(group, i) in groups"
          :key="`dropdown-val-group-${parent}-${schemaField.name}-${i}-${group.name}`"
          :value="group"
        >
          {{ group.name }}
        </option>
      </select>

  </div>
</template>

<script setup>
import {
  ref, computed, toRefs, onMounted, watch,
} from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useStore } from 'vuex';
import SVGIcon from '@/components/SVGIcon.vue';
import UidName from '@/components/Schema/UidName.vue';
import CreateDatasetTagDialog from '@/components/DatasetComponent/DatasetManagement/CreateDatasetTagDialog.vue';

const props = defineProps({
  parent: {
    type: String,
    default: '',
  },
  modelValue: {
    type: [Number, String, Object],
    default: null,
  },
  enableTagsSelection: {
   type: Boolean,
    default: true,
  },
  enableAnnotationSetSelection: {
   type: Boolean,
    default: false,
  },
  enableGroupSelection: {
   type: Boolean,
    default: false,
  },
   enableProjectSelection: {
   type: Boolean,
    default: true,
  },
  schemaField: {
    type: Object,
    default: () => {},
  },
  datasetId: {
    type: [Number, String],
    default: null,
  },
  tagName: {
    type: String,
    default: '',
  },  
  annotationSetId: {
    type: [Number, String],
    default: null,
  },
  trainGroupName: {
    type: String,
    default: '',
  },
  valGroupName: {
    type: String,
    default: '',
  },
  defaultValues: {
    type: Object,
    default: () => ({}),
  },
});

const {
  parent,
  schemaField,
  modelValue,
} = toRefs(props);

const hasProjectIdInDefaults = computed(() => props.defaultValues?.project_id !== undefined);

const emit = defineEmits(['update:modelValue', 'update:datasetId', 'update:tagName', 'update:annotationSetId', 'update:trainGroupName', 'update:valGroupName']);

// Use modelValue for v-model binding, fallback to datasetId prop
const internalDatasetId = computed({
  get: () => {
    if (modelValue?.value) {
      // If modelValue is an object with dataset_id property, extract it
      if (typeof modelValue.value === 'object' && 'dataset_id' in modelValue.value) {
        return modelValue.value.dataset_id;
      }
      return modelValue.value;
    }
    return props.datasetId;
  },
  set: (val) => {
    emit('update:modelValue', buildDatasetModelValue(val));
    emit('update:datasetId', val);
  }
});

async function getDatasets() {
  const projectId = selectedProjectId.value || currentProject.value?.id;
  if (projectId) {
    const dataConnect = new DatastoreConnect();
    const datasets = await dataConnect.getDatasetList({
      project_id: projectId,
      get_annotation_sets: true,
      get_groups: true,
    })
      .then((resp) => {
        if (resp.error) {
          throw resp.error;
        }
        return resp.result;
      })
      .catch((error) => {
        console.error(error);
      });

    return datasets;
  }
  return [];
}

const store = useStore();
const currentProject = computed(() => store.state.projects.currentProject);
const projects = ref([]);
const selectedProjectId = ref(null);
const datasets = ref(null);
const tags = ref([]);
const isLoadingTags = ref(false);
const selectedTag = ref('');
const showCreateTagDialog = ref(false);
const annotationSets = ref([]);
const selectedAnnotationSet = ref('');
const groups = ref([]);
const selectedTrainGroup = ref('');
const selectedValGroup = ref('');

const showNoTagsMessage = computed(() => props.enableTagsSelection
  && internalDatasetId.value
  && !isLoadingTags.value
  && tags.value.length === 0);

function buildDatasetModelValue(datasetId) {
  return {
    dataset_id: datasetId,
    project_id: selectedProjectId.value || currentProject.value?.id,
    tag_name: selectedTag.value,
    annotation_set_id: selectedAnnotationSet.value || null,
    train_group_name: selectedTrainGroup.value?.name || '',
    val_group_name: selectedValGroup.value?.name || '',
  };
}

async function getProjects() {
  try {
    const dataConnect = new DatastoreConnect();
    const response = await dataConnect.api('project.list', {});
    
    if (response.error) {
      throw response.error;
    }
    return response.result || [];
  } catch (error) {
    console.error('Error fetching projects:', error);
    return [];
  }
}

async function getTags(datasetId) {
  const parsedDatasetId = Number.parseInt(datasetId, 10);
  if (!Number.isInteger(parsedDatasetId) || parsedDatasetId <= 0) {
    tags.value = [];
    selectedTag.value = '';
    isLoadingTags.value = false;
    return;
  }
  
  isLoadingTags.value = true;
  selectedTag.value = '';
  const dataConnect = new DatastoreConnect();
  const tagList = await dataConnect.api("version.tag.list", {
    dataset_id: parsedDatasetId,
  })
    .then((resp) => {
      if (resp.error) {
        throw resp.error;
      }
      return resp.result;
    })
    .catch((error) => {
      console.error(error);
      return [];
    });
  
  tags.value = Array.isArray(tagList) ? tagList : [];
  isLoadingTags.value = false;
  
  // Set default to the latest (last) tag
  if (props.tagName && tags.value.some((tag) => tag.name === props.tagName)) {
    selectedTag.value = props.tagName;
  } else {
    if (tags.value && tags.value.length > 0) {
      selectedTag.value = tags.value[0].name;
    }
  }
}

function openCreateTagDialog() {
  showCreateTagDialog.value = true;
}

async function handleDatasetTagCreated({ tagName }) {
  await getTags(internalDatasetId.value);
  selectedTag.value = tagName;
}

async function getAnnotationSets(datasetId) {
  if (!datasetId) {
    annotationSets.value = [];
    selectedAnnotationSet.value = '';
    return;
  }
  
  const dataset = datasets.value?.find((d) => d.id === parseInt(datasetId));
  if (dataset && dataset.annotation_sets) {
    annotationSets.value = dataset.annotation_sets;
   
   if (props.annotationSetId) {
      selectedAnnotationSet.value = props.annotationSetId;
    } else {
      // Set default to the first annotation set
      if (annotationSets.value.length > 0) {
        selectedAnnotationSet.value = annotationSets.value[0].id;
      }
    }
  } else {
    annotationSets.value = [];
    selectedAnnotationSet.value = '';
  }
}

async function getGroups(datasetId) {
  if (!datasetId) {
    groups.value = [];
    selectedTrainGroup.value = '';
    selectedValGroup.value = '';
    return;
  }
  
  const dataset = datasets.value?.find((d) => d.id === parseInt(datasetId));
  if (dataset && dataset.groups) {
    groups.value = dataset.groups;

    if (props.trainGroupName) {
      const trainGroup = groups.value.find((g) => g.name === props.trainGroupName);
      if (trainGroup) {
        selectedTrainGroup.value = trainGroup;
      }
    } else {
      const trainGroup = groups.value.find((g) => g.name.toLowerCase().includes('train'));
      if (trainGroup) {
        selectedTrainGroup.value = trainGroup;
      }
    }

    if (props.valGroupName) {
      const valGroup = groups.value.find((g) => g.name === props.valGroupName);
      if (valGroup) {
        selectedValGroup.value = valGroup;
      }
    } else {
      const valGroup = groups.value.find((g) => g.name.toLowerCase().includes('val'));
      if (valGroup) {
        selectedValGroup.value = valGroup;
      }
    }
  } else {
    groups.value = [];
    selectedTrainGroup.value = '';
    selectedValGroup.value = '';
  }
}


function onChangeDataset(dsID) {
  const parsedDatasetId = Number.parseInt(dsID, 10);
  const hasValidDatasetId = Number.isInteger(parsedDatasetId) && parsedDatasetId > 0;

  emit('update:modelValue', buildDatasetModelValue(dsID));
   emit('update:datasetId', dsID);

   if (props.enableTagsSelection && hasValidDatasetId) {
    getTags(parsedDatasetId);
  } else {
    tags.value = [];
    selectedTag.value = '';
  }
  
  if (props.enableAnnotationSetSelection && hasValidDatasetId) {
    getAnnotationSets(parsedDatasetId);
  } else {
    annotationSets.value = [];
    selectedAnnotationSet.value = '';
  }
  
  if (props.enableGroupSelection && hasValidDatasetId) {
    getGroups(parsedDatasetId);
  } else {
    groups.value = [];
    selectedTrainGroup.value = '';
    selectedValGroup.value = '';
  }
  
}

function onChangeProject(projectIdValue) {
  const parsedProjectId = Number.parseInt(projectIdValue, 10);
  selectedProjectId.value = Number.isNaN(parsedProjectId) ? null : parsedProjectId;
}

watch(selectedProjectId, async (newValue) => {
  // Reload datasets when project changes
  if (newValue) {
    datasets.value = await getDatasets();
  } else {
    datasets.value = [];
  }

  // Reset dependent selections and propagate new project_id immediately.
  selectedTag.value = '';
  selectedAnnotationSet.value = '';
  selectedTrainGroup.value = '';
  selectedValGroup.value = '';
  annotationSets.value = [];
  groups.value = [];

  emit('update:modelValue', {
    dataset_id: null,
    project_id: newValue || null,
    tag_name: '',
    annotation_set_id: null,
  });
  emit('update:datasetId', null);
  emit('update:tagName', '');
  emit('update:annotationSetId', null);
});

watch(internalDatasetId, (newValue) => {
  if (newValue) {
    onChangeDataset(newValue);
  }
});

watch(selectedTag, (newValue) => {
  emit('update:tagName', newValue);
  
  // Also update the modelValue with the new tag_name
  emit('update:modelValue', buildDatasetModelValue(internalDatasetId.value));
});

watch(selectedAnnotationSet, (newValue) => {
  emit('update:annotationSetId', newValue);
  emit('update:modelValue', buildDatasetModelValue(internalDatasetId.value));
});

watch(selectedTrainGroup, (newValue) => {
  emit('update:trainGroupName', newValue?.name || '');
});

watch(selectedValGroup, (newValue) => {
  emit('update:valGroupName', newValue?.name || '');
});

watch(() => props.trainGroupName, (groupName) => {
  if (!groupName || !groups.value.length) {
    return;
  }
  const trainGroup = groups.value.find((g) => g.name === groupName);
  if (trainGroup) {
    selectedTrainGroup.value = trainGroup;
  }
});

watch(() => props.valGroupName, (groupName) => {
  if (!groupName || !groups.value.length) {
    return;
  }
  const valGroup = groups.value.find((g) => g.name === groupName);
  if (valGroup) {
    selectedValGroup.value = valGroup;
  }
});

onMounted(async () => {
  // If defaultValues provide project_id, emit it as modelValue immediately
  if (props.defaultValues?.project_id !== undefined) {
    emit('update:modelValue', {
      dataset_id: null,
      project_id: props.defaultValues.project_id,
      tag_name: null,
      annotation_set_id: null,
    });
  }

  // Fetch available projects
  projects.value = await getProjects();
  
  // If modelValue is passed as an object, extract values from it
  let initialProjectId = null;
  let initialDatasetId = null;
  let initialTagName = '';
  let initialAnnotationSetId = null;
  
  if (modelValue?.value && typeof modelValue.value === 'object') {
    initialProjectId = modelValue.value.project_id;
    initialDatasetId = modelValue.value.dataset_id;
    initialTagName = modelValue.value.tag_name || '';
    initialAnnotationSetId = modelValue.value.annotation_set_id || null;
  }
  
  // Set default project to current project or passed project_id
  if (initialProjectId) {
    selectedProjectId.value = initialProjectId;
  } else if (currentProject.value) {
    selectedProjectId.value = currentProject.value.id;
  } else if (projects.value && projects.value.length > 0) {
    selectedProjectId.value = projects.value[0].id;
  }
  
  datasets.value = await getDatasets();
  let dsID = initialDatasetId || props.datasetId || 0;
  
  if (dsID) {
    let ds = datasets.value.find(d => d.id === parseInt(dsID));
    if (ds) {
      dsID = ds.id;
    }
  }
  
  // Set tag name if provided
  if (initialTagName) {
    selectedTag.value = initialTagName;
  }

  if (initialAnnotationSetId) {
    selectedAnnotationSet.value = initialAnnotationSetId;
  }
  
  if (dsID) {
    onChangeDataset(dsID);
  }
});
</script>

<style scoped>
.label-spacing {
  display: block;
  margin-top: 6px;
  margin-bottom: 4px;
}

.empty-tags-state {
  width: 100%;
}

.empty-tags-state__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.empty-tags-state__message {
  color: #666;
  font-size: 0.9rem;
  text-align: left;
}

</style>
